// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_eg","postedByDate":"e_fg","mobileView":"e_gg"};